import { Form, useActionData } from "@remix-run/react"
import { useEffect, useState } from "react"
import { useRemixForm } from "remix-hook-form"
import { Label } from "~/components/ui/label"
import { cn } from "~/styles/utils"
import type { action } from "../_index"
import { type ContactFormSchemaType, ContactResolver } from "./contact.schemas"

const styles = {
  div: "space-y-2 w-full md:w-4/12 box-border pr-2",
  label: "text-gray-900",
}

const ContactForm = () => {
  const actionData = useActionData<typeof action>()
  const [result, setResult] = useState<string>('')

  const { register, handleSubmit, formState: { errors }, reset } = useRemixForm<ContactFormSchemaType>({
    mode: 'onSubmit',
    resolver: ContactResolver,
  })
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (actionData?.success) {
      if (actionData.data === 'basarili') {
        setResult('Mesajınız gönderildi')
        reset()
      } else {
        setResult('Mesajınız gönderilemedi')
      }
    }
  }, [actionData])

  return (
    <Form method="post" onSubmit={handleSubmit} className="space-y-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">İletişim Formu</h2>

      <div className="flex flex-wrap">
        <div className={styles.div}>
          <Label htmlFor="firma" className={styles.label}>FİRMA</Label>
          <input
            id="firma"
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            {...register('firmaAdi')}
          />
          {errors.firmaAdi && <p className="text-red-500">{errors.firmaAdi.message}</p>}
        </div>

        <div className={styles.div}>
          <Label htmlFor="adSoyad" className={styles.label}>AD/SOYAD *</Label>
          <input
            id="adSoyad"
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            {...register('adSoyad')}
          />
          {errors.adSoyad && <p className="text-red-500">{errors.adSoyad.message}</p>}
        </div>

        <div className={styles.div}>
          <Label htmlFor="telefon" className={styles.label}>TELEFON</Label>
          <input
            id="telefon"
            type="tel"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            {...register('telefon')}
          />
          {errors.telefon && <p className="text-red-500">{errors.telefon.message}</p>}
        </div>

        <div className={cn(styles.div, "w-full md:w-8/12")}>
          <Label htmlFor="konu" className={styles.label}>KONU *</Label>
          <input
            id="konu"
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            {...register('konu')}
          />
          {errors.konu && <p className="text-red-500">{errors.konu.message}</p>}
        </div>
        <div className={styles.div}>
          <Label htmlFor="email" className={styles.label}>E-MAIL *</Label>
          <input
            id="email"
            type="email"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            {...register('email')}
          />
          {errors.email && <p className="text-red-500">{errors.email.message}</p>}
        </div>
      </div>


      <div className={cn(styles.div, "!w-full")}>
        <Label htmlFor="mesaj" className={styles.label}>MESAJINIZ</Label>
        <textarea
          id="mesaj"
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          {...register('mesaj')}
        />
        {errors.mesaj && <p className="text-red-500">{errors.mesaj.message}</p>}
      </div>
      {result && <p className="text-green-500">{result}</p>}
      <button
        type="submit"
        className="bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition-colors cursor-pointer"
      >
        Mesajı Gönder
      </button>
    </Form>
  )
}

export default ContactForm